function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { forEachEnvelopeItem } from '@sentry/utils';
import { stripMetadataFromStackFrames, addMetadataToStackFrames } from '../metadata.js';
/**
 * Adds module metadata to stack frames.
 *
 * Metadata can be injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 *
 * When this integration is added, the metadata passed to the bundler plugin is added to the stack frames of all events
 * under the `module_metadata` property. This can be used to help in tagging or routing of events from different teams
 * our sources
 */

var ModuleMetadata = /*#__PURE__*/function () {
  /**
   * @inheritDoc
   */
  function ModuleMetadata() {
    _classCallCheck(this, ModuleMetadata);

    this.name = ModuleMetadata.id;
  }
  /**
   * @inheritDoc
   */


  _createClass(ModuleMetadata, [{
    key: "setupOnce",
    value: function setupOnce(addGlobalEventProcessor, getCurrentHub) {
      var client = getCurrentHub().getClient();

      if (!client || typeof client.on !== 'function') {
        return;
      } // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.


      client.on('beforeEnvelope', function (envelope) {
        forEachEnvelopeItem(envelope, function (item, type) {
          if (type === 'event') {
            var event = Array.isArray(item) ? item[1] : undefined;

            if (event) {
              stripMetadataFromStackFrames(event);
              item[1] = event;
            }
          }
        });
      });
      var stackParser = client.getOptions().stackParser;
      addGlobalEventProcessor(function (event) {
        addMetadataToStackFrames(stackParser, event);
        return event;
      });
    }
  }], [{
    key: "__initStatic",
    value:
    /*
     * @inheritDoc
     */
    function __initStatic() {
      this.id = 'ModuleMetadata';
    }
  }]);

  return ModuleMetadata;
}();

ModuleMetadata.__initStatic();

export { ModuleMetadata };